import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {lastValueFrom} from "rxjs";
import {ChangeEmailRequest, PerFormaAPIService, ProfileResponse} from "src/app/services/pfapi.service";

@Component({
    selector: "app-change-email",
    templateUrl: "./change-email.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeEmailComponent implements OnInit {
    form: FormGroup;
    profile?: ProfileResponse;
    error = "";
    success = false;
    submitting = false;
    // true when the user has no email yet (the forced "set your email" case)
    forced = false;

    constructor(
        private readonly fb: FormBuilder,
        private readonly api: PerFormaAPIService
    ) {
        this.form = this.fb.group({
            email: ["", [Validators.required, Validators.email]],
            confirmEmail: ["", [Validators.required, Validators.email]]
        });
    }

    async ngOnInit() {
        this.profile = await lastValueFrom(this.api.getApiProfile());
        this.forced = !(this.profile?.Email || "").trim();
    }

    handleSubmit = async () => {
        this.error = "";
        this.success = false;

        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(k => this.form.get(k)?.markAsTouched());
            return;
        }

        const {email, confirmEmail} = this.form.value;
        if (email !== confirmEmail) {
            this.error = "Email and confirmation email must match.";
            return;
        }

        const req: ChangeEmailRequest = {Email: email};
        this.submitting = true;
        try {
            await lastValueFrom(this.api.postApiProfileChangeEmail(req));
            this.success = true;
            this.forced = false;
            if (this.profile) this.profile.Email = email;
            this.form.reset();
        } catch (err) {
            this.error = this.extractError(err);
        } finally {
            this.submitting = false;
        }
    };

    private extractError(err: unknown): string {
        const anyErr = err as {error?: {errors?: Record<string, string[]>; detail?: string}};
        const modelState = anyErr?.error?.errors;
        if (modelState && typeof modelState === "object") {
            const messages = (Object.values(modelState) as string[][]).flat();
            if (messages.length) return messages.join(" ");
        }
        return anyErr?.error?.detail || "Something went wrong.";
    }
}
